import React from "react";
import PurchaseOrderLineItemRow from "./PurchaseOrderLineItemRow";
import Button from "../../ui/Button";

export default function PurchaseOrderLineItemsTable({
  lineItems = [],
  assemblyItemOptions,
  onLineItemAssemblySelect,
  updateLineItem,
  saveLineItem,
  lineSaveStatuses = {},
  removeLineItem,
  addLineItem,
}: any) {
  return (
    <section className="rounded-2xl border border-[#E2E8F0] bg-white p-5 shadow-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h2 className="text-base font-semibold text-[#0F172A]">
            Ordered items
          </h2>
          <p className="mt-1 text-sm text-[#64748B]">
            Add the raw materials, ingredients, packaging, or supplier items
            expected from this vendor.
          </p>
        </div>
        <Button
          type="button"
          variant="secondary"
          size="md"
          onClick={addLineItem}
        >
          + Add item
        </Button>
      </div>

      {lineItems.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-[#CBD5E1] bg-[#F8FAFC] px-6 py-10 text-center">
          <p className="text-sm font-medium text-[#0F172A]">
            No items added yet.
          </p>
          <p className="mt-1 text-sm text-[#64748B]">
            Add the materials you expect to receive from this supplier.
          </p>
          <Button
            type="button"
            variant="primary"
            size="md"
            className="mt-4"
            onClick={addLineItem}
          >
            Add first item
          </Button>
        </div>
      ) : (
        <div className="mt-5 overflow-x-auto">
          <table className="po-line-items-table min-w-[980px] w-full text-left text-sm">
            <thead>
              <tr className="border-b border-[#E2E8F0] bg-[#EFF6FF] text-[11px] font-semibold uppercase tracking-wide text-[#64748B]">
                <th className="px-3 py-2">Item</th>
                <th className="px-3 py-2">Ordered qty</th>
                <th className="px-3 py-2 text-right">Received</th>
                <th className="px-3 py-2 text-right">Fulfillment</th>
                <th className="px-3 py-2">Unit cost</th>
                <th className="px-3 py-2 text-right">Subtotal</th>
                <th className="px-3 py-2 text-right">Tax</th>
                <th className="px-3 py-2 text-right">Line total</th>
                <th className="px-3 py-2 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {lineItems.map((row: any) => (
                <PurchaseOrderLineItemRow
                  key={row.temp_id}
                  row={row}
                  assemblyItemOptions={assemblyItemOptions}
                  onAssemblySelect={onLineItemAssemblySelect}
                  updateLineItem={updateLineItem}
                  saveLineItem={saveLineItem}
                  saveStatus={lineSaveStatuses[String(row.temp_id)] ?? "idle"}
                  onRemove={removeLineItem}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
